export default {

    data() {
        return {
            //进入该页面从数据库里面获取当前视频看的时间
            sqlCurrentTime: 0,
            //根据websocket来判断是否需要启动离开视频是否需要获取
            isGetVideo: '',
            // websocket
            ws: null,
            //进度信息保存的定时器
            saveProcessInfo: null,
            //看完后保存一个时间
            endingTime: 0,
            //现在播放的最长时间，显示在右上角
            nowLongTime: 0,
            //获取现在课程播放时间
            nowTime: 0,
            //获取课程总时间
            sumTime: 0,
            // isImg: true,
            //右侧弹出的箭头图标改的标识
            arrowIcon: true,
            //考试id
            testId: '',
            //章节索引
            chapterIndex: '',
            //课时索引
            classIndex: '',
            //课时名字
            className: '',
            //课程详情
            classDetails: {},
            //获取现在播放时间的定时器
            timer: null,
            //视频vid
            videoUrl: '',
            //视频对象
            videoObj: '',
            // //视频的vid
            // url: '',
            //视频的章节资源
            resources: [],
            src: require('../../assets/images/arrows-right.png'),
            video: '',
            // 显示摄像区域
            showCamera: false,
            // 拍摄照片的url路径
            url: '',
            // 订单项id
            purchasedId: '',
            // 订单id
            orderId: '',
            // 订单下的套餐总共有多少个课程
            total: 0,
            // 课程包订单表的id
            categoryOrderId: '',
            // 是否自动播放
            isAutoPlay: false,
        }

    },
    methods: {
        // 存套餐进度
        categoryProgress() {
            this.$post('category_order/update', {
                id: this.categoryOrderId,
                category_progress: 1
            });

            // // 获取对应的category_id数据和order_id数据
            // this.$post('category_order/get', {
            //     id: this.categoryOrderId
            // }).then(res => {
            //     // 取出课程包对应的产品数组
            //     let cList = res.data.result.product_category_mapping;
            //     // 取出订单对应订单项数组
            //     let pList = res.data.result.purchased;
            //     // 筛选订单项数组，只要产品数组中c_product_id === 订单项数组中 p_product_id 的数据
            //     let list = [];
            //     for (let item1 of cList) {

            //         for (let item2 of pList) {

            //             if (item1.c_product_id === item2.p_product_id) {
            //                 list.push(item2);
            //             }
            //         }
            //     }

            //     // 计算当前课程包的进度
            //     let sum = list.reduce((sum, item) => {
            //         return sum += (item.progress * 1);
            //     }, 0);
            //     // let categoryProgress = Number.parseFloat(((sum * 100) / (list.length * 100)).toFixed(2));
            //     let categoryProgress = Number.parseFloat(((sum.toFixed(2) * 100) / (list.length * 100)).toFixed(2));
            //     // 如果进度等于1，记录完成时间
            //     let endTime = ''
            //     if (categoryProgress == 1) {
            //         endTime = this.getNetworkTime();
            //     }

            //     // 更新进度
            //     this.$post('category_order/update', {
            //         id: this.categoryOrderId,
            //         category_progress: categoryProgress,
            //         study_end_time: endTime
            //     });

            // })
        },
        //弹出章节目录
        displayChapter: function () {
            let percent = ((document.body.offsetWidth - 350) / document.body.offsetWidth) * 100;
            document.querySelector('body').style.cssText =
                `width:${percent}%;position:relative;left:0.001%;transition: all 350ms;`;
        },

        //回课程学习页面
        toClassStudy: function () {
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: this.$route.query.id,
                    purchased_id: this.$route.query.orderGoodsId,
                    categoryOrderId: this.categoryOrderId
                }
            })
        },
        //去课后习题页面
        toClassExam: function () {
            UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
            let address = this.$router.resolve({
                path: '/classexam',
                query: {
                    id: this.testId,
                    goodsId: this.$route.query.goodsId
                }
            });
            window.open(address.href, '_blank');
        },
        //获取视频页面的数据
        getData: function () {
            // 设置定时器300秒发送一次保存数据库的请求
            this.saveProcessInfo = setInterval(() => {
                this.otherLeaveVideo();
            }, 300000)
            this.chapterIndex = this.$route.query.chapterIndex;
            this.classIndex = this.$route.query.classIndex;
            this.className = this.$route.query.className;
            let me = this;
            //获取课程的视频章节信息
            if (me.$route.query.isRate.toString() == 'true') {
                me.$post('purchased/get', {
                    token: me.$store.state.id,
                    id: me.$route.query.orderGoodsId
                }).then(res => {
                    // 如果没有成绩，则发送请求将成绩设置为100
                    let score = res.data.result.score;
                    if (me.$isAbnormal(score)) {
                        me.$post('purchased/sumbitResult', {
                            id: me.$route.query.orderGoodsId,
                            private: JSON.stringify({}),
                            token: me.$store.state.id,
                            score: 100
                        });
                    }

                    // 如果rate不为空，进行赋值
                    let rate = res.data.result.rate;
                    if (!me.$isAbnormal(rate)) {
                        me.resources = JSON.parse(rate).resources;
                        for (let val of me.resources[0].items) {
                            if (me.$route.query.className == val.name) {
                                if (val.currentTime && val.currentTime != undefined) {
                                    me.sqlCurrentTime = Number.parseFloat(val.currentTime);
                                } else {
                                    me.sqlCurrentTime = 0;
                                }
                            }
                        }
                    }

                });

                // this.$post('orders/search', {
                //     token: this.$store.state.id,
                //     offset: 0,
                //     length: '999'
                // }).then(res => {
                //     return res.data.result.data;
                // }).then(data => {
                //     for (let val of data) {
                //         (function () {
                //             me.$post('purchased/search', {
                //                 token: me.$store.state.id,
                //                 order_id: val.id,
                //                 offset: 0,
                //                 length: '999'
                //             }).then(res => {
                //                 for (let item of res.data.result.data) {
                //                     if (Number.parseInt(me.$route.query.goodsId) == Number.parseInt(item.product_id) && val.state == 2) {
                //                         me.$post('products/get', {
                //                             id: me.$route.query.id,
                //                             token: me.$store.state.id
                //                         }).then(res => {
                //                             return res.data.result.project_id;
                //                         }).then(id_data => {
                //                             me.$post('projects/search', {
                //                                 id: id_data,
                //                                 token: me.$store.state.id
                //                             }).then(res => {
                //                                 me.$post('purchased/sumbitResult', {
                //                                     id: item.id,
                //                                     private: JSON.stringify({}),
                //                                     token: me.$store.state.id,
                //                                     score: 100
                //                                 }).then(res => {
                //                                     // console.log(res.data.result);
                //                                 })

                //                                 // let testObj = JSON.parse(res.data.result.resources).pop().items[0].resources;
                //                                 // //判断是否有题目，若有题目则获取题目id，否则让题目满分
                //                                 // if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
                //                                 // 	me.$post('purchased/sumbitResult', {
                //                                 // 		id: item.id,
                //                                 // 		private: JSON.stringify({}),
                //                                 // 		token: me.$store.state.id,
                //                                 // 		score: 100
                //                                 // 	}).then(res => {
                //                                 // 		// console.log(res.data.result);
                //                                 // 	})
                //                                 // } else {
                //                                 // 	me.testID = testObj[0];
                //                                 // }
                //                             });
                //                         })

                //                         if (!me.$isAbnormal(item.rate)) {
                //                             me.resources = JSON.parse(item.rate).resources;
                //                             for (let val of me.resources[0].items) {
                //                                 if (me.$route.query.className == val.name) {
                //                                     if (val.currentTime && val.currentTime != undefined) {
                //                                         me.sqlCurrentTime = Number.parseFloat(val.currentTime);
                //                                     } else {
                //                                         me.sqlCurrentTime = 0;
                //                                     }
                //                                 }
                //                             }
                //                         }
                //                     }
                //                 }
                //             })
                //         })(val)
                //     }
                // })
            } else {
                this.$post('products/get', {
                    id: this.$route.query.id,
                    token: me.$store.state.id
                }).then(res => {
                    return res.data.result.project_id;
                }).then(id_data => {
                    this.$post('projects/search2', {
                        id: id_data,
                        token: this.$store.state.id,
                        offset: 0,
                        length: 999
                    }).then(res => {
                        // 处理资源
                        let list = res.data.result.data;
                        let resources = [];
                        list.map(item => {
                            resources.push((JSON.parse(item.resources)[0]));
                        });

                        this.resources = resources;

                        // this.$post('purchased/sumbitResult', {
                        //     id: item.id,
                        //     private: JSON.stringify({}),
                        //     token: this.$store.state.id,
                        //     score: 100
                        // }).then(res => {
                        //     // console.log(res.data.result);
                        // })

                        // let testObj = this.resources.pop().items[0].resources;
                        // //判断是否有题目，若有题目则获取题目id，否则让题目满分
                        // if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
                        // 	this.$post('purchased/sumbitResult', {
                        // 		id: item.id,
                        // 		private: JSON.stringify({}),
                        // 		token: this.$store.state.id,
                        // 		score: 100
                        // 	}).then(res => {
                        // 		// console.log(res.data.result);
                        // 	})
                        // } else {
                        // 	this.testID = testObj[0];
                        // }

                    });
                })
            }

            //获取课程的基本信息
            this.$post('products/get', {
                id: this.$route.query.classId
            }).then(res => {
                this.classDetails = res.data.result;
            })
        },
        //点击视频章节切换不同视频
        toLearnVideo: function (resources, chapterIndex, classIndex, className, currentTime, allTime) {
            //离开页面让学习页面刷新进度
            this.nowLongTime = 0;
            this.sumTime = 0;
            this.nowTime = 0;
            if (currentTime && currentTime / allTime == 1) {
                UIkit.modal(document.querySelector('#modal-no-look')).show();
                return
            } else {
                let time = 0;
                let resources_url = '';
                currentTime ? time = currentTime : time = 0;
                this.chapterIndex = chapterIndex;
                this.classIndex = classIndex;
                this.leaveVideo();
                this.$post('resources/get', {
                    id: resources[0],
                    token: this.$store.state.id
                }).then(res => {
                    resources_url = res.data.result.data;
                    this.videoPlay(resources_url, time);
                    this.className = className;
                    document.title = className;
                    UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
                })
            }
        },
        //创建保利威视的视频对象
        videoPlay: function (url, time) {
            let currentTime = time;
            let numVal = ((1 - 140 / document.body.offsetHeight));
            let eleHeight = document.body.offsetHeight * numVal;
            let isAuth = this.$route.query.isAuth;

            // 要求畅和的视频可以拖动
            let isPlayer = 'on';
            if (this.$store.state.store.id == 110) {
                isPlayer = 'off'
            }

            let me = this;
            this.videoUrl = url;
            currentTime ? currentTime : currentTime = 0;
            // isAuth == '1' ? isPlayer : isPlayer = 'off';
            var player = polyvObject(
                "#plv_1"
            ).videoPlayer({
                width: 800,
                height: [eleHeight],
                vid: url,
                'flashvars': {
                    "watchStartTime": currentTime,
                    "ban_seek_by_limit_time": "off",
                    // "ban_seek_by_limit_time": isPlayer,
                    'ban_history_time': 'on',
                    'autoplay': 1
                }
            });
            this.videoObj = player;
            //计算上面视频右上角的定时器
            this.nowTime = this.timeResult(currentTime);
            this.timer = setInterval(function () {
                let baoliTime = me.videoObj.j2s_getCurrentTime();
                baoliTime >= me.nowLongTime ? me.nowLongTime = baoliTime : me.nowLongTime;
                me.nowTime = me.timeResult(Math.max(baoliTime, me.nowLongTime));
                me.sumTime = me.timeResult(me.videoObj.j2s_getDuration());
            }, 1000)
        },
        //返回00时00分00秒格式
        timeResult: function (time) {
            let secondTime = Number.parseInt(time);
            let minuteTime = 0;
            let hourTime = 0;
            let result = '';
            if (time > 60) {
                minuteTime = Number.parseInt(time / 60);
                secondTime = Number.parseInt(time % 60);
                if (minuteTime > 60) {
                    hourTime = Number.parseInt(minuteTime / 60);
                    minuteTime = Number.parseInt(minuteTime % 60);
                }
            }
            hourTime >= 10 ? result += hourTime + '时' : result += '0' + hourTime + '时';
            minuteTime >= 10 ? result += minuteTime + '分' : result += '0' + minuteTime + '分';
            secondTime >= 10 ? result += secondTime + '秒' : result += '0' + secondTime + '秒';
            return result;
        },

        //另一个触发方法
        otherLeaveVideo: function () {
            if (this.resources.length == 0) {
                return;
            }
            let obj = {};
            let resources = this.resources;
            let progress = 0;
            let chapter = resources.length;
            let sumClassTime = 0;
            let finishTime = 0;
            let nowTime = 0;
            //获取最大进度时间的值
            if (this.$route.query.currentTime) {
                nowTime = Math.max(Number.parseInt(this.$route.query.currentTime), this.videoObj.j2s_getCurrentTime(), this.endingTime,
                    this.sqlCurrentTime);
            } else {
                nowTime = Math.max(this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            }
            //用来保存继续学习的数据
            let continueClass = {
                chapterIndex: this.chapterIndex,
                classIndex: this.classIndex,
                className: this.className,
                currentTime: nowTime,
                items_resources: this.videoUrl,
                allTime: this.videoObj.j2s_getDuration(),
            };
            //循环计算总进度（按课时）/（按时间）
            for (let val of resources) {
                let joint = val.items.length;
                for (let v of val.items) {
                    sumClassTime += 1;
                    //判断如果是当前课程的话，就添加已经看的时间和总的时间
                    if (v.name == this.className) {
                        v.currentTime = nowTime;
                        v.allTime = this.videoObj.j2s_getDuration();
                    }
                    if (v.currentTime) {
                        v.currentTime >= v.allTime ? finishTime += 1 : finishTime;
                        progress += (v.currentTime / v.allTime / joint / chapter);
                    }
                }
            };
            //总进度=》按章节课程时长
            obj.classProgress = finishTime / sumClassTime;
            //章节资源。里面有章节时长和章节总时间
            obj.resources = resources;
            //考试id
            obj.testId = this.testId;
            //订单的商品id
            obj.orderGoodsId = this.$route.query.orderGoodsId;
            //若时间大于1则按照1输入，否则会出错
            progress > 1 ? progress = 1 : progress;
            //总进度=》按已看时长
            obj.progress = progress;
            //己住上传观看的课时
            obj.continueClass = continueClass;

            this.$post('purchased/getRate', {
                id: obj.orderGoodsId,
                token: this.$store.state.id
            }).then(res => {
                let progress = 0
                let rate = 0
                if (!this.$isAbnormal(res.data.result)) {
                    progress = res.data.result.progress
                    rate = res.data.result.rate
                }

                try {
                    // 只有当前进度大于上一次进度的时候才更新数据，否则按之前的进度存
                    if (obj.classProgress * 1 >= progress * 1) {
                        this.$post('purchased/sumbitRate', {
                            id: obj.orderGoodsId,
                            rate: JSON.stringify(obj),
                            progress: obj.classProgress,
                            token: this.$store.state.id
                        }).then(res => {
                            this.categoryProgress();
                        })
                    } else {
                        this.$post('purchased/sumbitRate', {
                            id: obj.orderGoodsId,
                            rate: rate,
                            progress: progress,
                            token: this.$store.state.id
                        }).then(res => {
                            this.categoryProgress();
                        })
                    }
                } catch {
                    this.$message.error('进度保存错误！！！');
                }
            })
            // .then(() => {
            //     // 如果选择自动播放和当前的视频已经看完
            //     if (this.isAutoPlay && continueClass.currentTime == continueClass.allTime) {
            //         this.autoPlay(continueClass.chapterIndex, continueClass.chapterIndex);
            //     }
            // })
            .catch((e) => {
                this.$message.error('进度保存错误！！！');
                console.log(e);
            });
        },

        //离开页面或者关闭浏览器触发请求
        leaveVideo: function (next) {
            if (this.isGetVideo == 'false' || this.resources.length == 0) {
                return;
            }
            // this.$root.isGetData=true;
            // alert(this.$root.isGetData=true);
            //离开页面让学习页面刷新进度

            //关掉视频时间的计时器
            clearInterval(this.timer);
            //关闭储存进度的定时器
            clearInterval(this.saveProcessInfo);
            //章节目录侧边栏隐藏
            UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
            let obj = {};
            let resources = this.resources;
            let progress = 0;
            let chapter = resources.length;
            let sumClassTime = 0;
            let finishTime = 0;
            let nowTime = 0;
            //获取最大进度时间的值
            if (this.$route.query.currentTime) {
                nowTime = Math.max(Number.parseInt(this.$route.query.currentTime), this.videoObj.j2s_getCurrentTime(), this.endingTime,
                    this.sqlCurrentTime);
            } else {
                nowTime = Math.max(this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            }
            //用来保存继续学习的数据
            let continueClass = {
                chapterIndex: this.chapterIndex,
                classIndex: this.classIndex,
                className: this.className,
                currentTime: nowTime,
                items_resources: this.videoUrl,
                allTime: this.videoObj.j2s_getDuration(),
            };
            //循环计算总进度（按课时）/（按时间）
            for (let val of resources) {
                let joint = val.items.length;
                for (let v of val.items) {
                    sumClassTime += 1;
                    //判断如果是当前课程的话，就添加已经看的时间和总的时间
                    if (v.name == this.className) {
                        v.currentTime = nowTime;
                        v.allTime = this.videoObj.j2s_getDuration();
                    }
                    if (v.currentTime) {
                        v.currentTime >= v.allTime ? finishTime += 1 : finishTime;
                        progress += (v.currentTime / v.allTime / joint / chapter);
                    }
                }
            }
            //总进度=》按章节课程时长
            obj.classProgress = finishTime / sumClassTime;
            //已经学的时长
            obj.finishTime = finishTime;
            //总时长
            obj.sumClassTime = sumClassTime;
            //章节资源。里面有章节时长和章节总时间
            obj.resources = resources;
            //考试id
            obj.testId = this.testId;
            //订单的商品id
            obj.orderGoodsId = this.$route.query.orderGoodsId;
            //若时间大于1则按照1输入，否则会出错
            progress > 1 ? progress = 1 : progress;
            //总进度=》按已看时长
            obj.progress = progress;
            //己住上传观看的课时
            obj.continueClass = continueClass;

            this.$post('purchased/getRate', {
                id: obj.orderGoodsId,
                token: this.$store.state.id
            }).then(res => {
                let progress = 0
                let rate = 0
                if (!this.$isAbnormal(res.data.result)) {
                    progress = res.data.result.progress
                    rate = res.data.result.rate
                }

                try {
                    // 只有当前进度大于上一次进度的时候才更新数据，否则按之前的进度存
                    if (obj.classProgress * 1 >= progress * 1) {
                        this.$post('purchased/sumbitRate', {
                            id: obj.orderGoodsId,
                            rate: JSON.stringify(obj),
                            progress: obj.classProgress,
                            token: this.$store.state.id
                        }).then(res => {
                            this.categoryProgress();
                            if (next) {
                                next()
                            }
                        })
                    } else {
                        this.$post('purchased/sumbitRate', {
                            id: obj.orderGoodsId,
                            rate: rate,
                            progress: progress,
                            token: this.$store.state.id
                        }).then(res => {
                            this.categoryProgress();
                            if (next) {
                                next()
                            }
                        })
                    }
                } catch {
                    this.$message.error('进度保存错误！！！');
                }
            }).catch(() => {
                this.$message.error('进度保存错误！！！');
            });
        },

        ////////////////////////////////////////////////////////////////摄像头功能//////////////////////////////////////////////////////////////

        // 开启摄像头按钮
        getMedia() {
            let video = this.video
            let constraints = {
                video: {
                    width: 300,
                    height: 300
                },
                audio: true
            };
			/*
			这里介绍新的方法:H5新媒体接口 navigator.mediaDevices.getUserMedia()
			这个方法会提示用户是否允许媒体输入,(媒体输入主要包括相机,视频采集设备,屏幕共享服务,麦克风,A/D转换器等)
			返回的是一个Promise对象。
			如果用户同意使用权限,则会将 MediaStream对象作为resolve()的参数传给then()
			如果用户拒绝使用权限,或者请求的媒体资源不可用,则会将 PermissionDeniedError作为reject()的参数传给catch()
			*/
            let promise = navigator.mediaDevices.getUserMedia(constraints);
            promise.then(function (MediaStream) {
                video.srcObject = MediaStream;
                video.play();
            }).catch(function (PermissionDeniedError) {
                // console.log(PermissionDeniedError);
            })
        },

        // 拍照按钮
        takePhoto() {
            let video = this.video

            //获得Canvas对象
            let canvas = document.getElementById("canvas");
            let ctx = canvas.getContext('2d');
            // 把canvas变成图片
            ctx.drawImage(video, 0, 0, 300, 300);

            // 保存canvas图片路径
            this.url = canvas.toDataURL("image/jpeg");

            // 把64位转化为8位数组形式
            // let u8Image = this.b64ToUint8Array(url);
        },

        // 上传拍摄的照片
        send() {
            this.$post('file/uploadBaseImg', {
                file: this.url,
                token: this.$store.state.id
            }).then(res => {
                // console.log(res)
                this.showCamera = false
            })
        },

        // 转格式  64转8位数组
        b64ToUint8Array(b64Image) {
            let img = atob(b64Image.split(',')[1]);
            let img_buffer = [];
            let i = 0;
            while (i < img.length) {
                img_buffer.push(img.charCodeAt(i));
                i++;
            }
            return new Uint8Array(img_buffer);
        },
        ////////////////////////////////////////////////////////////////摄像头功能//////////////////////////////////////////////////////////////

        // 获取订单信息
        getOrder() {
            this.$post('purchased/get_order_id', {
                token: this.$store.state.id,
                id: this.purchasedId
            }).then(res => {
                this.orderId = res.data.result.order_id;

                // 获取订单下套餐的课程数量
                // this.getProductNumber()
            })
        },

        // 获取网络时间
        getNetworkTime() {
            let xmlhttp;
            if (window.XMLHttpRequest) {
                // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
                xmlhttp = new XMLHttpRequest();
            } else {
                // IE6, IE5 浏览器执行代码
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }

            xmlhttp.open("GET", "https://quan.suning.com/getSysTime.do", false);
            xmlhttp.send();

            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                return JSON.parse(xmlhttp.responseText).sysTime2;
            } else {
                return '';
            }

        },

        // 页面关闭或刷新时调用
        beforeunloadFn() {
            // 关闭窗口时断开WebSocket连接
            this.ws.close();

            // 保存进度
            this.leaveVideo();
        },

        // 自动播放
        autoPlay(chapterIndex, itemIndex) {
            console.log('调用我了');
            console.log('当前章的索引：', chapterIndex);
            console.log('当前节的索引：', itemIndex);

            this.videoObj.changeVid('80949bbbdc70ef38011d4b5c700aab97_8', 0, 'on');
            
            // this.nowLongTime = 0;
            // this.sumTime = 0;
            // this.nowTime = 0;

            /**
             * //点击视频章节切换不同视频
        toLearnVideo: function (resources, chapterIndex, classIndex, className, currentTime, allTime) {
            //离开页面让学习页面刷新进度
            this.nowLongTime = 0;
            this.sumTime = 0;
            this.nowTime = 0;
            if (currentTime && currentTime / allTime == 1) {
                UIkit.modal(document.querySelector('#modal-no-look')).show();
                return
            } else {
                let time = 0;
                let resources_url = '';
                currentTime ? time = currentTime : time = 0;
                this.chapterIndex = chapterIndex;
                this.classIndex = classIndex;
                this.leaveVideo();
                this.$post('resources/get', {
                    id: resources[0],
                    token: this.$store.state.id
                }).then(res => {
                    resources_url = res.data.result.data;
                    this.videoPlay(resources_url, time);
                    this.className = className;
                    document.title = className;
                    UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
                })
            }
        },
             */
        }
    },

    //离开视频页面时候存储JSON信息到rate字段
    beforeRouteLeave: function (to, from, next) {
        // 关闭websocket连接
        this.ws.close();

        this.leaveVideo(next);
        // next();
    },

    created: function () {
        // 获取订单项id
        this.purchasedId = this.$route.query.orderGoodsId;
        // 获取订单
        this.getOrder();

        // 获取课程订单表的id
        this.categoryOrderId = this.$route.query.categoryOrderId;
    },
    mounted: function () {
        let me = this;

        // 获取媒体对象
        // let video = document.getElementById('video')
        // this.video = video
        // // 设置定时器，一分钟后拍摄照片
        // setTimeout(() => {
        //   this.$alert('系统将调用摄像头进行拍摄', '提示', {
        //     confirmButtonText: '确定',
        //     callback: action => {
        //       this.showCamera = true
        //       this.getMedia()
        //     }
        //   });
        // }, 2000)

        UIkit.util.on('#modal-studying', 'hidden', function () {
            me.$router.push({
                path: '/classstudy',
                query: {
                    id: me.$route.query.id,
                    purchased_id: me.$route.query.orderGoodsId
                }
            })
        });
        // console.log('WebSocket in window = ', "WebSocket" in window)
        if ("WebSocket" in window) {
            let id = me.$store.state.userId;
            var ws = new WebSocket("wss://runqin-socket.bayou-tech.cn/websocket?id=" + id + 'zzrc' + '&policy=2');
            // console.log('ws = ', ws)
            me.ws = ws;
            ws.open = function () {
            };
            // console.log('ws.onmessage ', ws.onmessage)
            ws.onmessage = (evt) => {
                // console.log('到我了')
                // console.log(JSON.parse(evt.data).success);
                if (JSON.parse(evt.data).success == 'true') {
                    me.isGetVideo = 'true';
                    //获取数据
                    me.getData();
                    //进入页面获取视频资源
                    me.videoPlay(me.$route.query.items_resources, me.$route.query.currentTime);
                    //页面标题
                    document.title = me.$route.query.className;
                    //关闭章节目录栏触发下面的方法使得视频大小恢复
                    UIkit.util.on('#offcanvas-push', 'hide', function () {
                        me.arrowIcon = !me.arrowIcon;
                        document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
                    });
                    //打开章节目录改变箭头图标
                    UIkit.util.on('#offcanvas-push', 'show', function () {
                        me.arrowIcon = !me.arrowIcon;
                    });
                    document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
                    //如果视频播放结束就执行这行代码获取总时间
                    window.s2j_onPlayOver = () => {
                        me.endingTime = me.videoObj.j2s_getDuration();
                        me.otherLeaveVideo()
                    }
                } else {
                    me.isGetVideo = 'false';
                    UIkit.modal(document.querySelector('#modal-studying')).show();
                }
            };
            // console.log('ws.onmessage ', ws.onmessage)
        }

        // 绑定关闭窗口事件
        window.addEventListener('beforeunload', e => me.beforeunloadFn(e));

    },

    destroyed() {
        // 移除事件
        window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    }

}
